import React from 'react';
import { DragDropContext } from '@hello-pangea/dnd';
import InProgressColumn from './InProgressColumn';

const InProgressBoard = ({
  dealStages,
  deals,
  onCardClick,
  onOpenClient,
  onOpenStaff,
  onDragEnd,
  staff = [],
}) => {
  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <div className="deals-board" data-testid="deals-kanban-board">
        <div className="deals-board__grid">
          {dealStages.map((stage) => {
            const stageDeals = deals.filter((deal) => deal.stage === stage);

            return (
              <InProgressColumn
                key={stage}
                stage={stage}
                deals={stageDeals}
                onCardClick={onCardClick}
                onOpenClient={onOpenClient}
                onOpenStaff={onOpenStaff}
                staff={staff}
              />
            );
          })}
        </div>
      </div>
    </DragDropContext>
  );
};

export default InProgressBoard;
